import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { FormValue } from '../useForm';
import Modal from 'src/components/custom/Modal';
import CategoriesList from '../CategoriesList';
import ProductList from '../ProductList';
import Tooltip from 'antd/es/tooltip';

type Props = {
  index: number;
  formInfo: UseFormReturn<FormValue, any>;
  dataReEstimates?: Response.QuotationItem[];
  dataReEstimate?: Response.QuotationItem;
  setDataReEstimate: (data: Response.QuotationItem[]) => void;
  resetInputData: (index: number) => void;
};

const ProductModal: React.FC<Props> = ({
  index,
  formInfo,
  dataReEstimates = [],
  dataReEstimate,
  setDataReEstimate,
  resetInputData,
}) => {
  const [draftVariety, setDraftVariety] = useState<string>('');
  const [draftShape, setDraftShape] = useState<string>('');
  const [draftProduct, setDraftProduct] = useState<string>('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { t } = useTranslation();
  const { setValue, getValues } = formInfo;
  const machiningItem = getValues(`priceQuotes.${index}.machiningItem`);

  useEffect(() => {
    if (isModalVisible) {
      setDraftVariety(dataReEstimate?.hinshL3Cd ?? '');
      setDraftShape(dataReEstimate?.keijoL3Cd ?? '');
      setDraftProduct(dataReEstimate?.product ?? '');
      setValue(`priceQuotes.${index}.isResetByProductSelection`, false);
    }
  }, [isModalVisible, dataReEstimate]);

  return (
    <Modal
      modalProps={{ width: 1120 }}
      title={t('product.product_search')}
      setIsModalVisible={setIsModalVisible}
      content={({ onClose }) => (
        <div className="products_modal">
          <div className="products_modal-body">
            <CategoriesList
              index={index}
              formInfo={formInfo}
              dataReEstimate={dataReEstimate}
              draftVariety={draftVariety}
              draftShape={draftShape}
              setDraftVariety={setDraftVariety}
              setDraftShape={setDraftShape}
              setDraftProduct={setDraftProduct}
            />
            <ProductList
              machiningMethod={machiningItem?.value || ''}
              dataReEstimate={dataReEstimate}
              draftVariety={draftVariety}
              draftShape={draftShape}
              draftProduct={draftProduct}
              setDraftVariety={setDraftVariety}
              setDraftShape={setDraftShape}
              formInfo={formInfo}
              index={index}
              dataReEstimates={dataReEstimates}
              setDataReEstimate={setDataReEstimate}
              resetInputData={resetInputData}
              onClose={onClose}
            />
          </div>
        </div>
      )}
    >
      <div className="product-name">
        {dataReEstimate?.hakudoShhnm && (
          <Tooltip
            title={dataReEstimate?.hakudoShhnm}
            color="#fff"
            overlayInnerStyle={{ color: '#000' }}
          >
            <Typography.Text
              className="product-name_label multi_line_ellipsis"
              ellipsis={true}
              style={{
                cursor: 'pointer',
              }}
            >
              {dataReEstimate?.hakudoShhnm}
            </Typography.Text>
          </Tooltip>
        )}
        <Button type="primary" className="btn-custom" style={{ minWidth: 75 }}>
          {t('multiple_quotes_page.selection')}
        </Button>
      </div>
    </Modal>
  );
};

export default ProductModal;
